<template>
  <section class="p-2">
    <div>
      <v-form>
        <v-card>
          <v-card-title class="d-flex justify-space-between p-0 m-0">
            <div class="ps-2 headingFontsize">Edit Branch-Main Branch</div>
            <div>
              <bread-crumb
                :bread-crumbs="[
                  'Partner Summary',
                  'Partner Branch',
                  'Edit Branch',
                ]"
              />
            </div>
          </v-card-title>

          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <!-- <v-toolbar flat dense>
            <v-toolbar-title>Edit Branch-Main Branch</v-toolbar-title>
          </v-toolbar> -->
          <!-- <div style="border:solid 1px;color:grey" class="ms-4 me-4"></div> -->
          <!-- <v-divider   style="border: solid 1px;color: green;  "></v-divider> -->

          <v-row class="mt-2 ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0 required">Name</label>
              <v-text-field outlined dense class="rounded" placeholder="Name">
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Address</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Address"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Contact Person</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Contact Person"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Email</label>
              <v-text-field outlined dense class="rounded" placeholder="Email">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Telephone</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Telephone"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Country</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Country"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">State</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Select State"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">city</label>
              <v-text-field outlined dense class="rounded" placeholder="city">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Letter Head</label>
              <v-textarea outlined dense class="rounded"> </v-textarea>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Access Code</label>
              <i style="font-size: 12px"
                >Recent Branch Code Used:AGRAIN Used for user Login</i
              >
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Access Code"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Ext.Branch Code</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Ext.Branch Code"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Branch Group</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Branch Group"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Branch Type</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Select Branch Type"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">District</label>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="District"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Bank Name</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Bank Name"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Branch Name</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Branch Name"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Account Number</label>
              <v-autocomplete
                outlined
                dense
                class="rounded"
                placeholder="Account Number"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3"
              ><v-switch
                label="Is the Main branch head office"
                switch
              ></v-switch
            ></v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Start Hour: </label>
              <i style="font-size: 12px">eg 1 to 24 </i>
              <v-text-field
                outlined
                dense
                class="rounded"
                placeholder="Start Hour"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">End Hour: </label>
              <i style="font-size: 12px">eg 1 to 24 </i>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="End Hour"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ms-1 me-1">
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Allow User Login Form </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="Allow User Login Form"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Branch Limit</label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="Branch Limit"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <label class="labelFontsize mb-0">Payout TRN.Limit </label>
              <v-text-field
                dense
                outlined
                class="rounded"
                placeholder="Payout TRN.Limit"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3"
              ><v-switch
                hide-details
                label="Can view report behind time limit"
              ></v-switch></v-col
          ></v-row>

          <v-row class="ms-4" no-gutters> </v-row>

          <v-row class="ms-1 me-1 mt-4">
            <v-col cols="12" md="3"><label>Created By:</label></v-col>
            <v-col cols="12" md="3"> <label>Approve By:</label></v-col>
            <v-col cols="12" md="3"><label>Last Update By:</label></v-col>
          </v-row>
          <div class="row">
            <div class="col-md-12" style="display: flex; justify-content: end">
              <v-btn depressed  small class="text-capitalize me-3 mb-10" color="primary"
                >Update</v-btn
              >
              <v-btn depressed 
                small
                class="text-capitalize me-4 mb-10"
                color="primary"
                outlined
                ><v-icon small class="me-2">mdi-close-circle-outline</v-icon>Cancel</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-form>
    </div>
  </section>
</template>
<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
export default {
  name:"Edit Branch",
  data: () => ({}),
  components: {
    BreadCrumb,
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
</style>
